import 'vue-awesome/icons/cog'
import 'vue-awesome/icons/volume-down'
import 'vue-awesome/icons/envelope'
import 'vue-awesome/icons/info-circle'
import 'vue-awesome/icons/paperclip'
import 'vue-awesome/icons/power-off'
import 'vue-awesome/icons/regular/smile'
import 'vue-awesome/icons/paper-plane'
import 'vue-awesome/icons/brands/facebook-square'
import 'vue-awesome/icons/brands/google-plus-square'
import 'vue-awesome/icons/edit'
import 'vue-awesome/icons/check'
import 'vue-awesome/icons/undo'
import 'vue-awesome/icons/angle-down'
import 'vue-awesome/icons/times-circle'
import 'vue-awesome/icons/calendar'
import 'vue-awesome/icons/phone'
import 'vue-awesome/icons/chevron-right'
import 'vue-awesome/icons/chevron-left'
import 'vue-awesome/icons/bell'
import 'vue-awesome/icons/phone-square'
import 'vue-awesome/icons/link'
import '../assets/css/v4-styles.css'

import * as push from './push.js'
import { Client, Server } from './client_server.js'

const g_client = new Client('widget_4_parent', window.parent)

import Vue from 'vue'
import { directive as onClickaway } from './lib/clickaway'
import VueTimeago from 'vue-timeago'
import store from './store'
import * as types from './store/mutation_types'
import { u as umbrella } from 'umbrellajs'
import * as utils from './utils'
import router from './router'
import i18n from './lib/i18n'

import storage from './lib/storage.js'
import eventHub from './lib/hub'
const objectPath = require('object-path')
import Icon from 'vue-awesome/components/Icon.vue'
import Viewport from './components/Viewport.vue'
import bowser from 'bowser'

let alertSound = null
let viewportVm = null
let presenceTimer = null
let g_totalPages = 0

// cookie.defaults.path = '/'
Vue.config.productionTip = false
Vue.component('v-icon', Icon)
Vue.directive('clickaway', onClickaway)
Vue.filter('capitalize', utils.capitalize)
Vue.filter('truncate', utils.truncate)
Vue.filter('absURL', utils.absURL)
Vue.use(VueTimeago, {
	name: 'timeago',
	locale: 'en',
	locales: {
		en: [
			'now',
			'%ss ago',
			'%sm ago',
			'%sh ago',
			'%sd ago',
			'%sw ago',
			'%sM ago',
			'%sy ago',
		],
		vi: [
			'vừa rồi',
			'%ss trước',
			'%sm trước',
			'%sh trước',
			'%sd trước',
			'%sw trước',
			'%sM trước',
			'%sy trước',
		],
	},
})

eventHub.$on('widget.expand', expandWidget)

async function expandWidget() {
	utils.sendEventToThirdParty(g_client, 'SUBIZ Chat', 'Opened', 'Subiz Windows')

	const lastScreenId = await store.state.lastScreenId
	const lastConvoId = await storage.get('last_convo_id', '')
	utils.log('lastConvoId', lastConvoId)

	const lastUnseenConvoId = objectPath.get(
		store.getters.lastUnseenMessage,
		'convoId',
		''
	)

	if (lastScreenId) {
		router.push({ name: 'custom-screen', params: { id: lastScreenId } })
	} else if (lastUnseenConvoId) {
		router.push({ name: 'convo', params: { convoId: lastUnseenConvoId } })
	} else if (lastConvoId) {
		router.push({ name: 'convo', params: { convoId: lastConvoId } })
	} else if (!store.state.convoListReady || store.state.totalConvo > 0) {
		router.push({ name: 'convo-list' })
	} else {
		router.push({ name: 'convo' })
	}
}

eventHub.$on('api.error', function(code) {
	if (
		!(
			code === 'wrong_account_in_credential' ||
			code === 'account_not_found' ||
			code === 'invalid_credential' ||
			code === 'wrong_user_in_credential' ||
			code === 'user_not_found' ||
			code === 'invalid_mask' ||
			code === 'user_is_blocked' ||
			code === 'domain_is_not_whitelisted'
		)
	) {
		return
	}

	if (code !== 'user_is_blocked' && code !== 'domain_is_not_whitelisted') {
		g_client.call('clear_browser_data')
	}

	store.commit(types.RESET)

	if (presenceTimer) {
		clearInterval(presenceTimer)
		presenceTimer = null
	}

	eventHub.$emit('widget.hide_iframe')
})

eventHub.$on('conversation_state_updated', async function(event) {
	const convoId = objectPath.get(event, 'data.conversation.id', '')
	const convoIds = store.getters.convoIds || {}
	if (!convoIds[convoId]) {
		utils.log('[event: conversation_joined] convo not found')
		const accountId = store.state.accountId
		await store.dispatch('getConvo', { accountId, convoId })
		await store.dispatch('getEvents', {
			accountId,
			convoId,
			limit: store.state.eventLimit,
			forceUpdate: true,
		})
	}

	store.commit(types.ADD_EVENT, { convoId, event })

	const convo = store.getters.getConvoById(convoId)

	if (objectPath.has(event, 'data.conversation.state')) {
		convo.state = objectPath.get(event, 'data.conversation.state')
	}

	store.commit(types.UPDATE_CONVO, { convoId, convo })
})

eventHub.$on('conversation_joined', async function(event) {
	const accountId = store.state.accountId
	const convoId = objectPath.get(event, 'data.conversation.id', '')
	const convoIds = store.getters.convoIds || {}
	if (!convoIds[convoId]) {
		utils.log('[event: conversation_joined] convo not found')
		await store.dispatch('getConvo', { accountId, convoId })
	}

	// server doesn't send events before conversation_joined occur
	// so re-get events of this conversation to ensure we dont miss any event
	await store.dispatch('getEvents', {
		accountId,
		convoId,
		limit: store.state.eventLimit,
		forceUpdate: true,
	})

	store.commit(types.ADD_EVENT, { convoId, event })

	const convo = store.getters.getConvoById(convoId)

	const members = objectPath.get(event, 'data.conversation.members', [])
	let joined = false
	for (const member of members) {
		for (const joinedMember of convo.members) {
			if (member.id === joinedMember.id) {
				joined = true
			}
		}

		if (!joined) {
			convo.members.push(member)
		}
	}

	store.commit(types.UPDATE_CONVO, { convoId, convo })
})

eventHub.$on('conversation_left', async function(event) {
	const convoId = objectPath.get(event, 'data.conversation.id', '')
	const convoIds = store.getters.convoIds || {}
	if (!convoIds[convoId]) {
		utils.log('[event: conversation_left] convo not found')
		const accountId = store.state.accountId
		await store.dispatch('getConvo', { accountId, convoId })
		await store.dispatch('getEvents', {
			accountId,
			convoId,
			limit: store.state.eventLimit,
			forceUpdate: true,
		})
	}

	store.commit(types.ADD_EVENT, { convoId, event })

	const convo = store.getters.getConvoById(convoId)
	const members = objectPath.get(event, 'data.conversation.members', [])

	for (const member in members) {
		for (let index in convo.members) {
			const joinedMember = convo.members[index]

			if (member.id === joinedMember.id) {
				convo.members.splice(index, 1)
			}
		}
	}

	store.commit(types.UPDATE_CONVO, { convoId, convo })
})

eventHub.$on('message_seen', async function(event) {
	const convoId = objectPath.get(event, 'data.message.conversation_id', '')
	const convoIds = store.getters.convoIds || {}
	if (!convoIds[convoId]) {
		utils.log('[event: message_seen] convo not found')
		const accountId = store.state.accountId
		await store.dispatch('getConvo', { accountId, convoId })
		await store.dispatch('getEvents', {
			accountId,
			convoId,
			limit: store.state.eventLimit,
			forceUpdate: true,
		})
	}

	store.commit(types.ADD_EVENT, { convoId, event })

	const eventId = objectPath.get(event, 'data.message.id', '')
	const seenMembers = objectPath.get(event, 'data.message.computed.seen', [])
	store.commit(types.UPDATE_SEEN_MESSAGE, {
		convoId,
		eventId,
		members: seenMembers,
	})
})

eventHub.$on('message_received', async function(event) {
	const convoId = objectPath.get(event, 'data.message.conversation_id', '')
	const eventId = objectPath.get(event, 'data.message.id', '')
	const convoIds = store.getters.convoIds || {}
	if (!convoIds[convoId]) {
		utils.log('[event: message_received] convo not found')
		const accountId = store.state.accountId
		await store.dispatch('getConvo', { accountId, convoId })
		await store.dispatch('getEvents', {
			accountId,
			convoId,
			limit: store.state.eventLimit,
			forceUpdate: true,
		})
	}

	store.commit(types.ADD_EVENT, { convoId, event })

	const receivedMembers = objectPath.get(
		event,
		'data.message.computed.received',
		[]
	)
	store.commit(types.UPDATE_RECEIVED_MESSAGE, {
		convoId,
		eventId,
		members: receivedMembers,
	})
})

eventHub.$on('user_info_updated', function(event) {
	const userAttribute = objectPath.get(event, 'data.user.attributes', [])
	const isBanned = userAttribute.find(
		atb => atb.key === 'is_ban' && atb.boolean === true
	)
	if (isBanned) {
		eventHub.$emit('api.error', 'user_is_blocked') // fake event
	}
})

eventHub.$on('message_sent', async event => {
	const eventId = event.id
	const eventIds = store.getters.eventIds || {}
	if (eventIds[eventId]) {
		utils.log('ignore: event is exist in store')
		return true
	}

	const convoIds = store.getters.convoIds || {}
	const convoId = objectPath.get(event, 'data.message.conversation_id', '')
	if (!convoIds[convoId]) {
		utils.log('[event: message_sent] convo not found')
		const accountId = store.state.accountId
		await store.dispatch('getConvo', { accountId, convoId })
		await store.dispatch('getEvents', {
			accountId,
			convoId,
			limit: store.state.eventLimit,
			forceUpdate: true,
		})
	}

	store.commit(types.ADD_EVENT, { convoId, event })

	const byId = objectPath.get(event, 'by.id', '')
	if (byId === store.state.userId) return

	alertSound && await alertSound.play()

	if (store.getters.receivedEventIds[event.id]) return

	const isReceived = await storage.get('received_message.' + event.id, false)
	if (isReceived) return
	storage.set('received_message.' + event.id, true, 10)

	utils.sendEventToThirdParty(g_client, 'SUBIZ Chat', 'Received', 'User')

	store.dispatch('markAsReceivedMessage', {
		accountId: store.state.accountId,
		convoId,
		messageId: eventId,
		userId: store.state.userId,
	})
})

eventHub.$on('widget.show_iframe', () =>
	g_client.call('set_style', { display: 'block' })
)

eventHub.$on('widget.hide_iframe', () =>
	g_client.call('set_style', { display: 'none' })
)

eventHub.$on('widget.move_iframe', element => {})

async function initLanguage(accountSetting) {
	const existLangCode = store.state.languageCode
	let langCode = accountSetting.language || ''
	const langPrefixURL = utils.absURL(accountSetting.language_url || '')
	let lang = {}

	if (utils.isValidLanguage(existLangCode)) {
		langCode = existLangCode
	}

	if (utils.isValidLanguage(langCode)) {
		langCode = langCode.toLowerCase()
		store.commit(types.SET_LANGUAGE_CODE, langCode)

		const customLangURL = utils.absURL(accountSetting.custom_language_url || '')

		// ignore custom language if set language by js api (existLangCode)
		if (customLangURL && !utils.isValidLanguage(existLangCode)) {
			utils.log('get base + custom language', langPrefixURL, customLangURL)

			const [baseLang, customLang] = await Promise.all([
				utils.getLanguage(`${langPrefixURL}${langCode}.json`),
				utils.getLanguage(customLangURL),
			])
			lang = utils.mergeLanguage(baseLang, customLang)
		} else {
			lang = await utils.getLanguage(`${langPrefixURL}${langCode}.json`)
		}
	} else {
		// detect from IP
		await store.dispatch('getGeoIP')
		const langCode = store.getters.languageCode
		store.commit(types.SET_LANGUAGE_CODE, langCode)
		lang = await utils.getLanguage(`${langPrefixURL}${langCode}.json`)
	}

	i18n.setLocaleMessage(langCode, lang)
	i18n.locale = langCode
	store.commit(types.SET_LANGUAGE_READY, true)
}

async function preloadAlertSound() {
	let alertFile = () =>
		import(/*webpackChunkName: "alert-mp3" */ '../assets/media/alert.mp3')
	if (!document.createElement('audio').canPlayType('audio/mpeg')) {
		alertFile = () =>
			import(/*webpackChunkName: "alert-ogg" */ '../assets/media/alert.ogg')
	}

	try {
		const sound = new window.Audio()
		sound.addEventListener(
			'canplaythrough',
			() => {
				alertSound = sound
			},
			false
		)
		sound.src = (await alertFile()).default
	} catch (e) {}
}

const justResize = old => {
	Vue.nextTick(_ => {
		const body = umbrella('.widget_body')
		const button = umbrella('.widget-button')
		const routeName = router.history.current.name

		if (routeName === 'chat-button') {
			if (button.length < 1) {
				console.log('[resize iframe] button element not found')
				return
			}
		} else {
			if (button.length < 1 || body.length < 1) {
				console.log('[resize iframe] button or body element not found')
				return
			}
		}

		const buttonSize = button.size()
		const windowMode = store.state.windowMode
		let width = ''
		let height = ''
		const shadowPadding = 30

		if (routeName === 'chat-button') {
			width = buttonSize.width + 2 * shadowPadding
			height = buttonSize.height + 2 * shadowPadding
			const previewMessage = umbrella('.preview')
			if (previewMessage.length > 0) {
				const previewMessageSize = previewMessage.size()
				if (previewMessageSize.width && previewMessageSize.height) {
					const bottomHeight = 70
					width = previewMessageSize.width + 2 * shadowPadding + 10
					height = previewMessageSize.height + 2 * shadowPadding + bottomHeight
				}
			}
		} else {
			// expand
			const bodySize = body.size()

			if (windowMode === 'mini') {
				width = Math.max(bodySize.width, buttonSize.width) + 2 * shadowPadding
				const bottomHeight = 100
				height = bodySize.height + 2 * shadowPadding + bottomHeight
			} else if (windowMode === 'mobile') {
				width = bodySize.width
				height = bodySize.height
			} else {
				// full
				width = bodySize.width + 2 * shadowPadding
				height = bodySize.height
			}
		}

		g_client.call('set_style', { width: width + 'px', height: height + 'px' })
	})
}

eventHub.$on('widget.ui_changed', justResize)

function initViewport() {
	utils.log('initViewport')
	const viewportEl = umbrella('meta[name="viewport"]')
	if (viewportEl.length < 1) {
		umbrella('head').append(umbrella('<meta name="viewport" content="">'))
	} else {
		let modifiedViewport = utils.cloneDeep(store.state.modifiedViewport)
		const originViewport = utils.parseViewportContent(
			viewportEl.first().content
		)
		modifiedViewport = Object.assign({}, modifiedViewport, originViewport)
		const viewport = utils.cloneDeep(originViewport)

		utils.log('origin Viewport:', originViewport)
		utils.log('modified Viewport:', modifiedViewport)

		store.commit(types.SET_ORIGIN_VIEWPORT, originViewport)
		store.commit(types.SET_MODIFIED_VIEWPORT, modifiedViewport)
		store.commit(types.SET_VIEWPORT, viewport)
	}

	if (!viewportVm) {
		viewportVm = new Vue(Viewport)
		viewportVm.$mount('meta[name="viewport"]')
	}
}

async function initCSS(accountSetting) {
	const position =
		accountSetting.theme.widget_position === 'left' ? 'left' : 'right'
	const positionCSS = {}
	positionCSS[position] = '0px'
	g_client.call('set_style', positionCSS)
	store.commit(types.SET_POSITION, position)

	const customCssURL = utils.absURL(accountSetting.custom_css_url || '')
	let customCSS = ''
	if (customCssURL) {
		utils.log('get custom css', customCssURL)
		customCSS = await utils.getCSS(customCssURL)
	}
	if (bowser.mobile) customCSS += `\nbody { right: 0px; }`
	appendInlineStyle(document.body, customCSS)
	store.commit(types.SET_CSS_READY, true)
}

// appendInlineStyle creates an <style>css_content</style> node inside the parent node
function appendInlineStyle(parentNode, css_content) {
	var style = document.createElement('style')
	parentNode.appendChild(style)

	style.type = 'text/css'
	if (style.styleSheet) {
		// This is required for IE8 and below.
		style.styleSheet.cssText = css_content
	} else {
		style.appendChild(document.createTextNode(css_content))
	}
}

async function init(userMask, userId, urlRef = '') {
	console.log("INIT", userMask, userId, urlRef)
	g_totalPages = await storage.get('total_pages', 0)
	let isOffline = utils.getUrlParameter(urlRef, 'is_offline') || ''
	if (isOffline === 'yes') {
		store.commit(types.SET_OFFLINE, true)
	}

	// prevent duplicate widget loading
	if (window._sbz_loaded) return
	window._sbz_loaded = true

	utils.log(`Subiz Version: ` + process.env.VUE_APP_VERSION)

	new Vue({
		store,
		router,
		i18n,

		mounted() {
			store.commit(types.SET_DOM_READY, true)
			eventHub.$emit('widget.ui_changed', 'main640')
		},

		render(h) {
			return h(
				'div',
				{
					class: this.className,
					style: { width: '100%', height: '100%' },
					on: {
						mouseenter: this.onMouseEnter,
						mouseleave: this.onMouseLeave,
					},
				},
				[h('router-view')]
			)
		},
		methods: {
			onMouseEnter() {
				this.$store.commit(types.SET_HOVERING, true)
			},
			onMouseLeave() {
				this.$store.commit(types.SET_HOVERING, false)
			},
		},
		computed: {
			className() {
				const windowMode = this.$store.state.windowMode
				let name = `widget_${windowMode}`

				const position = this.$store.state.position
				if (position === 'left') name += ` left_bottom`
				if (windowMode === 'mobile') return name
				name += bowser.tablet ? ` widget_tablet` : ` widget_desktop`
				return name
			},
		},
	}).$mount('#app')

	await preloadAlertSound()

	await utils.sleep(50)

	// modify viewport
	initViewport()

	let accountId = store.state.accountId
	if (!accountId) {
		accountId = window._sbz_accountId
		store.commit(types.SET_ACCOUNT_ID, accountId)
	}

	if (userMask !== '') {
		const parts = userMask.split('@')
		if (!parts[0] || parts[0] !== accountId) {
			userId = ''
			userMask = ''
			g_client.call('clear_browser_data')
		}
	}

	// new user
	if (userId === '' || userMask === '') {
		await store.dispatch('getBaseSetting', accountId)
		userId = store.state.userId
		userMask = store.state.userMask
	}

	if (userId === '' || userMask === '') {
		const user = await store.dispatch('createUser', accountId)
		userId = user.id
		userMask = user.mask
	}

	store.commit(types.SET_USER_ID, userId)
	store.commit(types.SET_USER_MASK, userMask)
	store.commit(types.SET_USER_READY, true)

	store.dispatch('getSetting', { accountId, userId })
	store.dispatch('initWebsocket', { accountId, userId })
	return { user_id: userId, user_mask: userMask }
}

// Use store watch because:
// - some js api called (relate offline mode) before vue instance is ready,
// so `watch` in vue not run
// - fetch resources ASAP (not depend on vue)

store.watch(
	state => state.cssReady && state.languageReady && state.domReady,
	async ready => {
		if (!ready) return

		const lastConvoId = await storage.get('last_convo_id', '')
		const isOpeningConvo = await storage.get('is_opening_convo', false)
		if (isOpeningConvo && lastConvoId && !bowser.mobile) {
			utils.log(
				`[chat button] last convo id exist --> go to convo ${lastConvoId}`
			)
			router.push({ name: 'convo', params: { convoId: lastConvoId } })
		} else {
			router.push({ name: 'chat-button' })
		}

		eventHub.$emit('widget.ui_changed', 'main743')
		eventHub.$emit('widget.show_iframe')
	},
	{ immediate: true }
)

store.watch(
	state => {
		return (
			state.userReady &&
			state.settingReady &&
			state.cssReady &&
			state.languageReady &&
			state.wsReady &&
			state.domReady
		)
	},
	ready => {
		if (!ready) return
		store.commit(types.SET_ALL_READY, true)
		eventHub.$emit('widget.ui_changed', 'main763')
		eventHub.$emit('widget.show_iframe')

		// tracking
		store.dispatch('sendPresence', {
			accountId: store.state.accountId,
			userId: store.state.userId,
			device: store.state.device,
		})

		store.dispatch('sendContent', {
			accountId: store.state.accountId,
			userId: store.state.userId,
			device: store.state.device,
			pageUrl: store.state.parent_href,
			pageTitle: store.state.parent_title,
		})

		store.dispatch('recordDomain', {
			accountId: store.state.accountId,
			userId: store.state.userId,
			pageUrl: store.state.parent_href,
		})

		presenceTimer = setInterval(() => {
			store.dispatch('sendPresence', {
				accountId: store.state.accountId,
				userId: store.state.userId,
				device: store.state.device,
			})
		}, 25 * 1000)

		let e = document.createElement('div')
		e.classList.add('color-theme-default')
		let color = window.getComputedStyle(e).getPropertyValue('background-color')
		store.commit(types.SET_THEME_COLOR, color || '#4285f4')

		push.init(store.state.accountId, store.state.userId, store.state.parent_href)
	},
	{ immediate: true }
)

store.watch(
	state => state.baseSettingReady && state.domReady,
	ready => {
		if (!ready) return
		utils.log('base setting ready --> init css')

		initCSS(store.state.accountSetting)

		// set windowMode
		let windowMode = store.state.accountSetting.theme.window_mode
		if (bowser.mobile) windowMode = 'mobile'
		// test mobile
		//windowMode = 'mobile'
		store.commit(types.SET_WINDOW_MODE, windowMode)

		eventHub.$on('widget.custom_css', c => appendInlineStyle(document.body, c))

		const position = objectPath.get(
			store.state,
			'accountSetting.theme.widget_position',
			'right'
		)
		if (position === 'left') {
			document.body.style.right = 'auto'
			document.body.style.left = '0px'
		}
	},
	{ immediate: true }
)

store.watch(
	state => state.baseSettingReady,
	ready => {
		if (!ready) return
		utils.log('base setting ready --> init language')

		// get language
		initLanguage(store.state.accountSetting)
	},
	{ immediate: true }
)

store.watch(
	state => state.wsReady,
	ready => {
		if (!ready) return
		store.dispatch('getConversations', {
			accountId: store.state.accountId,
			userId: store.state.userId,
		})
	},
	{ immediate: true }
)

store.watch(
	state => state.settingReady,
	ready => {
		if (!ready) return
		utils.log('setting ready')

		const attributes = objectPath.get(store.state.user, 'attributes', [])
		const isBanned = attributes.find(
			a => a.key === 'is_ban' && a.boolean === true
		)
		if (isBanned) {
			eventHub.$emit('api.error', 'user_is_blocked') // fake event
		}
	},
	{ immediate: true }
)

store.watch(
	(state, getters) => getters.lastUnseenMessage,
	message => {
		if (store.getters.countUnseenConvos() < 1) {
			g_client.call('reset_title')
			return
		}
		let agentName = objectPath.get(message, 'agentInfo.fullname', '')
		if (agentName) agentName = ' ' + utils.capitalize(agentName) + ' '
		g_client.call(
			'set_title',
			`(${store.getters.countUnseenConvos()}) ${agentName} ${i18n.t(
				'conversations_unread'
			)}`
		)
	},
	{ immediate: true }
)

router.afterEach((to, from) => {
	utils.log('route changed', 'from: ' + from.name, ' to: ' + to.name)


	if (to.name !== 'convo') {
		storage.remove('is_opening_convo')
	}

	if (bowser.mobile) {
		// is chat button
		if (from.name !== 'chat-button' && to.name === 'chat-button') {
			utils.log('change to origin Viewport')
			store.commit(types.SET_VIEWPORT, store.state.originViewport)
		}

		// expand
		if (from.name === 'chat-button' && to.name !== 'chat-button') {
			utils.log('change to modified Viewport')
			store.commit(types.SET_VIEWPORT, store.state.modifiedViewport)
		}
	}

	if (from.name !== to.name) {
		eventHub.$emit('widget.ui_changed', 'main915')
	}
})

// =====================================================================================================
// JSAPI

storage.set('total_pages', ++g_totalPages, 60)

// prevent expire
setInterval(() => {
	storage.set('total_pages', g_totalPages, 60)
}, 10 * 1000)

const trackers = {}

trackers.scroll = options => {
	if (!options.x && !options.y) return

	let fired = false
	const handleScroll = utils.throttle(() => {
		if (fired) return

		let totalMatched = 0
		const body = document.body
		const html = document.documentElement

		const scrollTop = html.scrollTop || body.scrollTop
		const winHeight = html.clientHeight
		const docHeight = Math.max(
			body.scrollHeight,
			body.offsetHeight,
			html.clientHeight,
			html.scrollHeight,
			html.offsetHeight
		)

		const xPercent = Math.round((scrollTop / (docHeight - winHeight)) * 100)

		if (options.x) {
			const x = parseFloat(options.x)
			if (options.x.indexOf('%') !== -1 && xPercent >= x) {
				totalMatched++
			} else if (options.x.indexOf('px') !== -1 && scrollTop >= x) {
				totalMatched++
			}
		}

		const scrollLeft = html.scrollLeft || body.scrollLeft
		const winWidth = html.clientWidth
		const docWidth = Math.max(
			body.scrollWidth,
			body.offsetWidth,
			html.clientWidth,
			html.scrollWidth,
			html.offsetWidth
		)

		const yPercent = Math.round((scrollLeft / (docWidth - winWidth)) * 100)

		if (options.y) {
			const y = parseFloat(options.y)
			if (options.y.indexOf('%') !== -1 && yPercent >= y) {
				totalMatched++
			} else if (options.y.indexOf('px') !== -1 && scrollLeft >= y) {
				totalMatched++
			}
		}

		if (utils.size(options) === totalMatched && !fired) {
			fired = true
			eventHub.$emit('public.page_scroll', options)
			window.removeEventListener('scroll', handleScroll)
		}
	}, 5)

	window.addEventListener('scroll', handleScroll)
}

trackers.bounce = () => {
	let fired = false
	const handleMouseleave = () => {
		if (fired) return
		if (g_totalPages > 1) return
		fired = true
		eventHub.$emit('public.page_bounce')
		umbrella(document.body).off('mouseleave', handleMouseleave)
	}

	// use document.body because document doesnt work on firefox
	umbrella(document.body).on('mouseleave', handleMouseleave)
}

trackers.exit = () => {
	let fired = false
	const handleMouseleave = () => {
		if (fired) return
		fired = true
		eventHub.$emit('public.page_exit')
		umbrella(document.body).off('mouseleave', handleMouseleave)
	}

	// use document.body because document doesnt work on firefox
	umbrella(document.body).on('mouseleave', handleMouseleave)
}

const noop = () => {}

const waitAllReady = async ms => {
	ms = ms || 1000
	const timeout = 60000
	const startTime = +new Date()
	while (!store.state.userReady && +new Date() - startTime < timeout) {
		await utils.sleep(ms)
	}
}

const waitCssReady = async ms => {
	ms = ms || 1000
	const timeout = 60000
	const startTime = +new Date()
	while (!store.state.cssReady && +new Date() - startTime < timeout) {
		await utils.sleep(ms)
	}
}

const apiV4 = {}
new Server('widget_4_iframe', apiV4)

apiV4._setDevice = device => store.commit(types.SET_DEVICE, device)

const waitLanguageReady = async ms => {
	ms = ms || 1000
	const timeout = 60000
	const startTime = +new Date()
	while (!store.state.languageReady && +new Date() - startTime < timeout) {
		await utils.sleep(ms)
	}
}

apiV4.setLanguageData = async data => {
	if (!data) return
	await waitLanguageReady()
	if (!i18n.locale) return
	let messages = i18n.messages[i18n.locale] || {}
	i18n.setLocaleMessage(i18n.locale, { ...messages, ...data })
}

apiV4._init = (title, href, mask, userid) => {
	document.body.style.position = 'absolute'
	document.body.style.bottom = '0px'
	document.body.style.right = '0px'
	document.body.style.overflow = 'hidden'

	store.commit(types.SET_PARENT_TITLE, title)
	store.commit(types.SET_PARENT_HREF, href)
	return init(mask, userid, href)
}

apiV4._resize = (innerHeight, innerWidth) => {
	document.body.style.height = innerHeight + 'px'
	document.body.style.width = innerWidth + 'px'
	justResize()
}

apiV4._emit = (event, data) => { eventHub.$emit(event, data); return true; }

apiV4.setAccount = id => {
	console.log("SET", id)
	if (window._sbz_accountId) {
		return
	}
	window._sbz_accountId = id
	if (store.state.accountId) return
	store.commit(types.SET_ACCOUNT_ID, id)
}

apiV4._setAccount = apiV4.setAccount // deprecated

apiV4.setPosition = async position => {
	if (!utils.isValidPosition(position)) return
	await waitAllReady()
	const positionCSS = {}
	positionCSS[position] = '0px'
	g_client.call('set_style', positionCSS)
}

apiV4.setWindowMode = async windowMode => {
	if (!utils.isValidWindowMode(windowMode)) return
	await waitAllReady()
	store.commit(types.SET_WINDOW_MODE, windowMode)
}

apiV4.setLanguage = async code => {
	if (!utils.isValidLanguage(code)) return
	store.commit(types.SET_LANGUAGE_CODE, code)

	if (objectPath.has(i18n.messages, code)) {
		utils.log('exist language', code)
		i18n.locale = code
		return
	}

	// load language if not exist
	const langPrefixURL = utils.absURL(
		objectPath.get(store.state, 'accountSetting.language_url', '')
	)
	if (utils.isEmpty(langPrefixURL)) return
	const lang = await utils.getLanguage(`${langPrefixURL}${code}.json`)
	if (utils.isEmpty(lang)) return

	i18n.setLocaleMessage(code, lang)
	i18n.locale = code
}

apiV4.updateUserAttributes = async (attributes) => {
	await waitAllReady()

	const accountId = store.state.accountId
	const userId = store.state.userId

	await store.dispatch('updateUser', {
		accountId,
		userId,
		data: { attributes },
	})

	const finalAttributes = utils.unionBy(
		attributes,
		objectPath.get(store.state.user, 'attributes', []),
		'key'
	)
	return utils.cloneDeep(finalAttributes)
}

apiV4.getUserAttributes = async () => {
	await waitAllReady()
	const attributes = objectPath.get(store.state.user, 'attributes', [])
	return utils.cloneDeep(attributes)
}

apiV4.expandWidget = async () => {
	await waitAllReady()
	expandWidget(router, store)
	return true
}

apiV4.shrinkWidget = async () => {
	await waitAllReady()
	router.push({ name: 'chat-button' })
}

apiV4.changeCss = async css => {
	await waitCssReady()
	eventHub.$emit('widget.custom_css', css)
	eventHub.$emit('widget.ui_changed', 'main1188')
	return true
}

// chỉ xóa định danh ở trình duyệt, không xóa dữ liệu thật
apiV4.forgetMe = () => g_client.call('clear_browser_data')

apiV4.deleteUser = apiV4.forgetMe // deprecated

apiV4.showWidget = async () => {
	await waitAllReady()
	eventHub.$emit('widget.show')
}

apiV4.hideWidget = async () => {
	await waitAllReady()
	eventHub.$emit('widget.hide')
}

apiV4.showChatButton = async () => {
	await waitAllReady()
	eventHub.$emit('widget.show_chat_button')
}

apiV4.showButton = apiV4.showChatButton // deprecated

apiV4.hideChatButton = async () => {
	await waitAllReady()
	eventHub.$emit('widget.hide_chat_button')
}

apiV4.hideButton = apiV4.hideChatButton // deprecated

apiV4.showCloseButton = async () => {
	await waitAllReady()
	eventHub.$emit('widget.show_close_button')
}

apiV4.showButtonClose = apiV4.showCloseButton // deprecated

apiV4.hideCloseButton = async () => {
	await waitAllReady()
	eventHub.$emit('widget.hide_close_button')
}

apiV4.hideButtonClose = apiV4.hideCloseButton // deprecated

apiV4.onWidgetShrank = async () => {
	await waitAllReady()
	eventHub.$on('widget.shrank')
	return true
}

apiV4.minimizeWidget = apiV4.onWidgetShrank // deprecated

apiV4.subscribePushNotification = async () => {
	await waitAllReady(500)
	const result = await store.dispatch('subscribePushNotification')
	return result
}

apiV4.unsubscribePushNotification = async () => {
	await waitAllReady(500)
	const result = await store.dispatch('unsubscribePushNotification')
	return result
}

apiV4.checkPushNotification = async () => {
	await waitAllReady(500)
	const result = await store.dispatch('checkPushNotification')
	return result
}

apiV4.track = async (name, options) => {
	if (!trackers[name]) return
	trackers[name](options)
}

apiV4.emitEvent = async (eventName, data) => {
	eventHub.$emit(`public.${eventName}`, data)
}

apiV4.onEvent = async (eventName) => {
	eventHub.$on(`public.${eventName}`)
	return true
}

apiV4.openScreen = (screenId, html) => {
	if (!screenId && !html) return
	router.push({ name: 'custom-screen', params: { id: screenId, html: html } })
}

apiV4.openSetting = async navigationName => {
	await waitAllReady()
	eventHub.$emit('widget.openSetting', navigationName)
}

// TODO
apiV4.askPushNotification = noop
apiV4.askInfo = noop
apiV4.askFeedback = noop
apiV4.showProduct = noop

const timerMap = {}

apiV4.startTimer = (interval, limit) => {
	const startTime = +new Date()
	let count = 0
	limit = limit || 1
	const timerId = setInterval(() => {
		count++
		if (count > limit) {
			apiV4.stopTimer(timerId)
			return
		}

		eventHub.$emit('public.timer_triggered', {
			timerId: timerId,
			eventNumber: count,
			currentTime: +new Date(),
			startTime: startTime,
			interval: interval,
			limit: limit,
		})
	}, interval)

	timerMap[timerId] = { startTime: startTime, interval: interval, limit: limit }
	return timerId
}

apiV4.stopTimer = timerId => {
	clearInterval(timerId)
	const timer = timerMap[timerId]
	if (!timer || !timer.startTime) return
	const now = +new Date()
	eventHub.$emit('public.timer_stopped', {
		timerId: timerId,
		currentTime: now,
		startTime: timer.startTime,
		elapsedTime: now - timer.startTime,
		interval: timer.interval,
		limit: timer.limit,
	})
	delete timerMap[timerId]
}

apiV4._setOffline = () => {
	store.commit(types.SET_OFFLINE, true)
	return true
}

apiV4._setAllReady = () => {
	if (!store.state.isOffline) return
	store.commit(types.SET_USER_READY, true)
	store.commit(types.SET_BASE_SETTING_READY, true)
	store.commit(types.SET_SETTING_READY, true)
	store.commit(types.SET_WS_READY, true)
	store.commit(types.SET_CONVO_LIST_READY, true)
	store.commit(types.SET_CONVO_LIST_END, true)
}

apiV4._setSetting = setting => {
	if (!store.state.isOffline) return
	store.commit(types.SET_SETTING, setting)
}

apiV4._resetStore = () => {
	if (!store.state.isOffline) return
	store.commit(types.RESET)
}

apiV4._addConvo = async convo => {
	if (!store.state.isOffline) return
	store.commit(types.ADD_CONVO, { convo })
}

apiV4._addEvent = async (convoId, event) => {
	if (!store.state.isOffline) return
	store.commit(types.ADD_EVENT, { convoId, event })
}

apiV4._deleteEvents = async convoId => {
	if (!store.state.isOffline) return
	store.commit(types.DELETE_EVENTS, { convoId })
}

apiV4._updateEvent = (convoId, event) => {
	if (!store.state.isOffline) return
	store.commit(types.UPDATE_EVENT, { convoId, event })
}

apiV4._viewConvo = convoId => {
	if (!store.state.isOffline) return
	router.push({ name: 'convo', params: { convoId } })
}

apiV4._viewConvoList = () => {
	if (!store.state.isOffline) return
	router.push({ name: 'convo-list' })
}

apiV4._viewChatButton = () => {
	if (!store.state.isOffline) return
	router.push({ name: 'chat-button' })
}

apiV4._moveIframe = element => {
	if (!store.state.isOffline) return
	eventHub.$emit('widget.move_iframe', element)
}

apiV4._setLanguageData = (code, data) => {
	if (!store.state.isOffline) return
	i18n.setLocaleMessage(code, data)
	i18n.locale = code
	store.commit(types.SET_LANGUAGE_READY, true)
}

apiV4.fetchDone = (req_id, resp) => {}

apiV4.version = async (a, b) => {
	await utils.sleep(300)
	return '4.237'
}

// tell parent to init api
g_client.call('initapi')
